export default {"src":"/_next/static/media/bat.1bdd7546.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};